import React from 'react';

const SubContact = () => {
  return (
    <section className='sub-text-box' id='sub-text-box'>
      <h1>Contact</h1>
      <p>WHAT A DELIGHT TO HEAR FROM YOU.</p>
    </section>
  );
};

export default SubContact;
